<template>
  <div>
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: String
  }
};
</script>
